import React, { Fragment, useState, useEffect } from "react";
import moment from "moment";
import Modal from "../../layout/Modal";

const renderParticipantForm = ({ quantity, handleOnChange, participants }) => {
  let template = [];
  for (let i = 1; i <= quantity; i++) {
    template.push(
      <Fragment>
        <tr>
          <td>
            <h5>Peserta {i} </h5>
          </td>
        </tr>
        <tr>
          <td>Nama</td>
          <td>:</td>
          <td>
            <input
              className="form-control"
              name={"name" + i}
              onChange={handleOnChange}
              value={participants[i - 1].name}
              placeholder="Akhwew Caesur"
            />
          </td>
        </tr>
        <tr>
          <td>Nomor Telepon</td>
          <td>:</td>
          <td>
            <input
              className="form-control"
              name={"phone" + i}
              onChange={handleOnChange}
              value={participants[i - 1].phone}
              placeholder="+628122713xxxx"
            />
          </td>
        </tr>
        <tr>
          <td>Email</td>
          <td>:</td>
          <td>
            <input
              className="form-control"
              name={"email" + i}
              type="email"
              onChange={handleOnChange}
              value={participants[i - 1].email}
              placeholder="akhwew@xxx.com"
            />
          </td>
        </tr>
        <tr>
          <td>Nama Instansi</td>
          <td>:</td>
          <td>
            <input
              className="form-control"
              name={"institute" + i}
              onChange={handleOnChange}
              value={participants[i - 1].institute}
              placeholder="Kementerian Komunikasi dan Informatika"
            />
          </td>
        </tr>
        <tr>
          <td colspan="3">&nbsp;</td>
        </tr>
      </Fragment>
    );
  }
  return template;
};

export default ({
  handleRegister,
  showForm,
  handleCloseForm,
  event,
  handleAddQuantity,
  handleOnChange,
  quantity,
  participants,
  isValid,
}) => {
  return (
    <Modal show={showForm} handleClose={handleCloseForm}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header" style={{ padding: "20px 30px" }}>
            <p className="modal-title">
              <h4>Lengkapi Informasi Untuk Mendaftar</h4>
            </p>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => handleCloseForm()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body" style={{ padding: "30px" }}>
            <div id="form-daftar" action="">
              <div
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <p style={{ fontSize: "16px", fontWeight: "600" }}>
                    {event.title}
                  </p>
                  <p className="text-muted">
                    {moment(event.startDate).format("ddd, MMMM DD")},{" "}
                    {event.startTime}
                  </p>
                </div>
                <div>
                  <label>Jumlah</label>
                  <select
                    className="select-primary form-control"
                    id=""
                    style={{ width: "50px", padding: "10px" }}
                    onChange={handleAddQuantity}
                    value={quantity}
                  >
                    {/* <option hidden="" selected="">Jumlah</option> */}
                    <option value="1">1</option>
                    <option value="2">2</option>
                  </select>
                </div>
              </div>
              <table width="100%">
                <tbody>
                  {renderParticipantForm({
                    quantity,
                    handleOnChange,
                    participants,
                  })}
                </tbody>
              </table>
              <div
                className="d-flex mt-5"
                style={{ justifyContent: "flex-end" }}
              >
                <div
                  className="text-muted"
                  onClick={() => handleCloseForm()}
                  style={{ cursor: "pointer" }}
                >
                  Tidak Jadi
                </div>
                <button
                  type="submit"
                  className="btn btn-blue ml-4"
                  onClick={handleRegister}
                  disabled={isValid ? false : true}
                >
                  Daftar Acara
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
